var _excluded = ["containerClassName", "element", "line", "onCalculated", "onTruncated", "text", "textElement", "textTruncateChild", "truncateText", "showTextBeforeTruncation", "shouldUseObservers"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
/* eslint-disable react/sort-comp */
import React from 'react';

// Based on https://github.com/ShinyChang/react-text-truncate
// Mostly rewritten by ppaskaris for performance and quality.

var DefaultStyle = {};
var reWhitespace = /\s+/g;

// An exhaustive expression for hyphenation.
//
// eslint-disable-next-line max-len
var ccHyphenation = "\\u002D\\u058A\\u05BE\\u1400\\u1806\\u2010-\\u2015\\u2E17\\u2E1A\\u2E3A\\u2E3B\\u2E40\\u301C\\u3030\\u30A0\\uFE31\\uFE32\\uFE58\\uFE63\\uFF0D";
var reHyphenated = new RegExp("[^".concat(ccHyphenation, "][").concat(ccHyphenation, "]+$"));

// Splits the string on any contiguous whitespace or any word boundary that proceeds a hyphen, producing the following
// after post-processing:
//
//     Input: 'Did you just do a "double-take?"'
//    Output: ['Did', 'you', 'just', 'do', 'a', '"double-', 'take?"']
//
// Post-processing is performed to avoid using a lookbehind assertion, which is not supported in Safari and other Webkit
// browsers.
//
// eslint-disable-next-line max-len
var reTokenize = new RegExp("(\\s+|[".concat(ccHyphenation, "]+\\b)"));
var reHyphenOnly = new RegExp("^[".concat(ccHyphenation, "]+$"));
var TextTruncate = /*#__PURE__*/function (_React$Component) {
  function TextTruncate() {
    var _this;
    _classCallCheck(this, TextTruncate);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TextTruncate, [].concat(args));
    _defineProperty(_this, "scope", undefined);
    _defineProperty(_this, "canvas", undefined);
    _defineProperty(_this, "_observer", undefined);
    _defineProperty(_this, "rafId", undefined);
    _defineProperty(_this, "prevBoundingClientRectWidth", undefined);
    _defineProperty(_this, "state", {
      textAfterTruncation: undefined
    });
    _defineProperty(_this, "_enqueueUpdate", function () {
      if (!_this.rafId) {
        _this.rafId = window.requestAnimationFrame(_this._updateWithinAnimationFrame);
      }
    });
    _defineProperty(_this, "onResize", function () {
      _this.prevBoundingClientRectWidth = undefined;
      _this._enqueueUpdate();
    });
    _defineProperty(_this, "_observerCallback", function (entries) {
      var entry = entries[0];
      if (_this.prevBoundingClientRectWidth !== entry.boundingClientRect.width) {
        _this.prevBoundingClientRectWidth = entry.boundingClientRect.width;
        _this._enqueueUpdate();
      }
    });
    _defineProperty(_this, "onTruncated", function () {
      if (typeof _this.props.onTruncated === 'function') {
        setTimeout(_this.props.onTruncated, 0);
      }
    });
    _defineProperty(_this, "onCalculated", function () {
      if (typeof _this.props.onCalculated === 'function') {
        setTimeout(_this.props.onCalculated, 0);
      }
    });
    _defineProperty(_this, "_updateWithinAnimationFrame", function () {
      _this.rafId = undefined;
      var textAfterTruncation = _this._truncateTextWithinAnimationFrame();
      if (textAfterTruncation !== _this.state.textAfterTruncation) {
        _this.setState({
          textAfterTruncation: textAfterTruncation
        });
      }
      _this.onCalculated();
    });
    _defineProperty(_this, "measureWidth", function (text) {
      return _this.canvas.measureText(text).width;
    });
    _defineProperty(_this, "_setScope", function (scope) {
      _this.scope = scope;
    });
    return _this;
  }
  _inherits(TextTruncate, _React$Component);
  return _createClass(TextTruncate, [{
    key: "_shouldUseObservers",
    get: function get() {
      return Boolean(this.props.shouldUseObservers) && 'IntersectionObserver' in window;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.scope) {
        window.addEventListener('resize', this.onResize);
        if (this._shouldUseObservers) {
          this._observer = new IntersectionObserver(this._observerCallback, {
            root: null,
            threshold: 0
          });
          this._observer.observe(this.scope);
        } else {
          this._enqueueUpdate();
        }
        var canvas = document.createElement('canvas');
        document.createDocumentFragment().appendChild(canvas);
        this.canvas = canvas.getContext('2d');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.canvas = undefined;
      if (this._observer) {
        this._observer.disconnect();
        this._observer = undefined;
      }
      window.removeEventListener('resize', this.onResize);
      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = undefined;
      }
      this.prevBoundingClientRectWidth = undefined;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this._shouldUseObservers) {
        // In legacy mode, we always enqueue an update when we render, so we don't have to try and be fancy about it.
        return;
      }
      var prevProps = this.props;
      var prevStyle = prevProps.style != null ? prevProps.style : DefaultStyle;
      var nextStyle = nextProps.style != null ? nextProps.style : DefaultStyle;
      var shouldRecalculate = nextProps.text !== prevProps.text || nextStyle.fontStyle !== prevStyle.fontStyle || nextStyle.fontVariant !== prevStyle.fontVariant || nextStyle.fontWeight !== prevStyle.fontWeight || nextStyle.fontSize !== prevStyle.fontSize || nextStyle.fontFamily !== prevStyle.fontFamily || nextProps.containerClassName !== prevProps.containerClassName || nextProps.line !== prevProps.line;
      if (shouldRecalculate) {
        this._enqueueUpdate();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps, nextState) {
      var prevState = this.state;
      var didTruncationChange = nextState.textAfterTruncation !== prevState.textAfterTruncation;
      if (didTruncationChange) {
        var didTruncate = nextState.textAfterTruncation !== nextProps.text;
        if (didTruncate) {
          this.onTruncated();
        }
      } else if (!this._shouldUseObservers) {
        // Legacy behaviour: update on every render. Something might be relying on this, so until we finish the rewrite
        // with ResizeObserver, keep updating on non-noop renders just in case. Note that doing this deferred fixes the
        // original "zero length on display" bug that I set out to fix before I (ppaskaris) got my nose in here.
        //
        // This will not infinitely loop, as a meaningful update will trigger a truncation change, and a noop update will
        // not cause a render.
        this.prevBoundingClientRectWidth = undefined;
        this._enqueueUpdate();
      }
    }
  }, {
    key: "_updateCanvasForMeasure",
    value: function _updateCanvasForMeasure() {
      var _window$getComputedSt = window.getComputedStyle(this.scope),
        fontStyle = _window$getComputedSt['font-style'],
        fontVariant = _window$getComputedSt['font-variant'],
        fontWeight = _window$getComputedSt['font-weight'],
        fontSize = _window$getComputedSt['font-size'],
        fontFamily = _window$getComputedSt['font-family'];
      this.canvas.font = "".concat(fontStyle, " ").concat(fontVariant, " ").concat(fontWeight, " ").concat(fontSize, " ").concat(fontFamily);
    }
  }, {
    key: "_truncateTextWithinAnimationFrame",
    value: function _truncateTextWithinAnimationFrame() {
      var _this$props = this.props,
        line = _this$props.line,
        text = _this$props.text,
        truncateText = _this$props.truncateText;
      if (!this.scope) {
        return undefined;
      }

      // Cannot rely on this.prevBoundingClientRectWidth due to a blink quirk (it's rounded down).
      var scopeWidth = this.scope.getBoundingClientRect().width;

      // Return undefined instead of '' because we want non-block-level elements to auto-size themselves when they are made
      // visible.
      if (scopeWidth === 0) {
        return undefined;
      }
      this._updateCanvasForMeasure();
      return TextTruncate.truncate(text, truncateText, scopeWidth, line, this.measureWidth);
    }
  }, {
    key: "getRenderText",
    value: function getRenderText() {
      /* eslint-disable no-unused-vars */
      var _this$props2 = this.props,
        containerClassName = _this$props2.containerClassName,
        element = _this$props2.element,
        line = _this$props2.line,
        onCalculated = _this$props2.onCalculated,
        onTruncated = _this$props2.onTruncated,
        text = _this$props2.text,
        textElement = _this$props2.textElement,
        textTruncateChild = _this$props2.textTruncateChild,
        truncateText = _this$props2.truncateText,
        showTextBeforeTruncation = _this$props2.showTextBeforeTruncation,
        shouldUseObservers = _this$props2.shouldUseObservers,
        props = _objectWithoutProperties(_this$props2, _excluded);
      /* eslint-enable no-unused-vars */
      var textAfterTruncation = this.state.textAfterTruncation;
      if (textAfterTruncation == null) {
        return showTextBeforeTruncation ? /*#__PURE__*/React.createElement(textElement, props, text) : null;
      }
      if (textAfterTruncation.length <= 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement(textElement, props, textAfterTruncation);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        element = _this$props3.element,
        _this$props3$style = _this$props3.style,
        style = _this$props3$style === void 0 ? DefaultStyle : _this$props3$style,
        containerClassName = _this$props3.containerClassName;
      var fontStyle = style.fontStyle,
        fontVariant = style.fontVariant,
        fontWeight = style.fontWeight,
        fontSize = style.fontSize,
        fontFamily = style.fontFamily;
      var renderText = this.getRenderText();
      var rootProps = {
        ref: this._setScope,
        className: containerClassName,
        style: {
          overflow: 'hidden',
          fontStyle: fontStyle,
          fontVariant: fontVariant,
          fontWeight: fontWeight,
          fontSize: fontSize,
          fontFamily: fontFamily
        }
      };
      return /*#__PURE__*/React.createElement(element, rootProps, renderText);
    }
  }], [{
    key: "tokenize",
    value: function tokenize(text) {
      var parts = text.split(reTokenize);
      // Post-process to avoid lookbehind assertion, which is not supported in Safari and other Webkit browsers. We
      // capture the delimiters we split by to remove the whitespace tokens and left-merge the hyphenations, excluding
      // hyphens that are their own tokens, e.g. "Name - Description"
      var tokens = [];
      for (var i = 0, prevWasWhitespace = false; i < parts.length; ++i) {
        var part = parts[i];
        if (part.length <= 0 || reWhitespace.test(part)) {
          prevWasWhitespace = true;
        } else if (!prevWasWhitespace && reHyphenOnly.test(part)) {
          tokens[tokens.length - 1] += part;
          prevWasWhitespace = false;
        } else {
          tokens.push(part);
          prevWasWhitespace = false;
        }
      }
      return tokens;
    }
  }, {
    key: "truncate",
    value: function truncate(text, ellipsis, maxWidth, maxLines, measureText) {
      if (maxWidth <= 0) {
        return '';
      }
      if (maxLines <= 0) {
        return '';
      }
      var tokens = TextTruncate.tokenize(text);
      var len = tokens.length;
      var delimiter = ' ';
      var delimiterWidth = measureText(delimiter);
      var measureText0 = new Map();
      measureText0.set(delimiter, delimiterWidth);
      var i = 0;
      var result = '';
      var linesRemaining = maxLines;
      var widthRemaining = maxWidth;
      var shouldAppendDelimiter = false;

      // Basic greedy algorithm with hyphenation support.
      for (i = 0; i < len; ++i) {
        var token = tokens[i];
        var tokenWidth = measureText0.get(token);
        if (tokenWidth == null) {
          tokenWidth = measureText(token);
          measureText0.set(token, tokenWidth);
        }
        if (shouldAppendDelimiter) {
          result += delimiter;
          widthRemaining -= delimiterWidth;
        }
        result += token;
        widthRemaining -= tokenWidth;
        shouldAppendDelimiter = !reHyphenated.test(token);
        if (widthRemaining < 0) {
          linesRemaining -= 1;
          if (linesRemaining <= 0) {
            break;
          }
          widthRemaining = maxWidth - tokenWidth;
        }
      }

      // If we ran to completion, no truncation was necessary.
      if (i >= len && widthRemaining >= 0) {
        return result;
      }
      var ellipsisWidth = measureText0.get(ellipsis);
      if (ellipsisWidth == null) {
        ellipsisWidth = measureText(ellipsis);
        measureText0.set(ellipsis, ellipsisWidth);
      }

      // We accumulate error as we wrap. This most commonly manifests on the last line. We'll try rounding up on the final
      // line to mitigate it. We can't do this for earlier lines because the browser will make stuff fit, even snugly. In
      // future, we should measure the full line of text, using binary search as a speed up.
      ellipsisWidth = Math.ceil(ellipsisWidth);
      widthRemaining = Math.floor(widthRemaining);

      // Reclaim any space necessary to fit the ellipsis.
      if (ellipsisWidth > widthRemaining) {
        var j;

        // Walk back from the end reclaiming enough space so that the ellipsis fits comfortably. Assumption: we won't have
        // to reclaim too many characters, so repeatedly calling measureText with single characters is ok.
        for (j = result.length - 1; j >= 0 && ellipsisWidth > widthRemaining; --j) {
          var _char = void 0;

          // This disaster handles surrogate pairs, e.g. emojis 😎
          var charCode = result.charCodeAt(j);
          if (j > 0 && charCode >= 0xdc00 && charCode <= 0xdfff) {
            var charCode0 = result.charCodeAt(j - 1);
            if (charCode0 >= 0xd800 && charCode0 <= 0xdbff) {
              _char = String.fromCharCode(charCode0) + String.fromCharCode(charCode);
              --j;
            }
          }
          if (_char == null) {
            _char = String.fromCharCode(charCode);
          }
          var charWidth = measureText0.get(_char);
          if (charWidth == null) {
            charWidth = measureText(_char);
            measureText0.set(_char, charWidth);
          }
          widthRemaining += charWidth;
        }

        // Also trim any trailing delimiters.
        while (j > 0 && result.charAt(j) === delimiter) {
          --j;
        }
        result = result.slice(0, j + 1);
      }
      return result + ellipsis;
    }
  }]);
}(React.Component);
_defineProperty(TextTruncate, "defaultProps", {
  element: 'div',
  line: 1,
  text: '',
  textElement: 'div',
  truncateText: '…',
  showTextBeforeTruncation: true,
  shouldUseObservers: false
});
export { TextTruncate as default };